import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader } from 'lucide-react';
import { adminApi } from '../../api/client';
import { useLanguage } from '../../context/LanguageContext';
import ProfileView from '../../components/dashboard/ProfileView';
import './AdminHome.css';
import './AdminTranslatorProfilePage.css';

export default function AdminVerifierProfilePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const a = useMemo(() => t.dashboard?.admin || {}, [t.dashboard]);
  const [user, setUser] = useState(null);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    setBusy(true);
    adminApi.getVerifier(id)
      .then((res) => setUser(res.verifier))
      .catch(() => setError(a.notFound || 'Vérificateur non trouvé'))
      .finally(() => setBusy(false));
  }, [id, a]);

  if (busy) {
    return (
      <div className="atp-page">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, color: 'var(--dash-muted)' }}>
          <Loader size={22} className="spin" />
          <span>Chargement du profil…</span>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="atp-page">
        <button type="button" className="atp-back" aria-label={a.back || 'Retour'} onClick={() => navigate('/admin/verifiers')}>
          <ArrowLeft size={20} />
        </button>
        <div className="atp-card">
          <p>{error || a.notFound || 'Vérificateur non trouvé'}</p>
        </div>
      </div>
    );
  }

  const space = user.role === 'lawyer' ? 'lawyer' : user.role === 'notary' ? 'notary' : 'legal';

  return (
    <div className="atp-page">
      <button type="button" className="atp-back" aria-label={a.back || 'Retour'} onClick={() => navigate('/admin/verifiers')}>
        <ArrowLeft size={20} />
      </button>
      <div className="atp-card">
        <ProfileView user={user} space={space} />
      </div>
    </div>
  );
}
